import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsagePaymentDetailsComponent } from './usage-payment-details/usage-payment-details.component';
import { DppUsageComponent } from './dpp-usage/dpp-usage.component';

const routes: Routes = [
	{ path: 'dpp-payments', component: DppUsageComponent},
	{ path: 'usage-payments', component: UsagePaymentDetailsComponent},
	{ path: 'usage-payments/:month', component: UsagePaymentDetailsComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsagePaymentsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/payment/usage-payments/usage-payments-routing.module.ts